export default __webpack_public_path__ + "static/media/7.f6741b8e.svg";